module.exports = __webpack_public_path__ + "img/DefaultV.da4c0580.png";